import { EquipmentType } from 'app/features/search/model/aircraft-equipment';

export function getMonthDates(monthName: string) {
    const months = effectivePeriods();

    const month = months.find(m => m.name === monthName.toUpperCase());
    if (month) {
        return { start: month.start, end: month.end };
    } else {
        return { start: null, end: null };
    }
}

export function effectivePeriods() {
    const currentYear = new Date().getFullYear();
    return [
        { start: `${currentYear}-01-01T00:00`, end: `${currentYear}-01-30T23:59`, name: "JAN", epMonth: 1 },
        { start: `${currentYear}-01-31T00:00`, end: `${currentYear}-03-01T23:59`, name: "FEB", epMonth: 2 },
        { start: `${currentYear}-03-02T00:00`, end: `${currentYear}-03-31T23:59`, name: "MAR", epMonth: 3 },
        { start: `${currentYear}-04-01T00:00`, end: `${currentYear}-05-01T23:59`, name: "APR", epMonth: 4 },
        { start: `${currentYear}-05-02T00:00`, end: `${currentYear}-06-01T23:59`, name: "MAY", epMonth: 5 },
        { start: `${currentYear}-06-02T00:00`, end: `${currentYear}-07-01T23:59`, name: "JUN", epMonth: 6 },
        { start: `${currentYear}-07-02T00:00`, end: `${currentYear}-07-31T23:59`, name: "JUL", epMonth: 7 },
        { start: `${currentYear}-08-01T00:00`, end: `${currentYear}-08-30T23:59`, name: "AUG", epMonth: 8 },
        { start: `${currentYear}-08-31T00:00`, end: `${currentYear}-09-30T23:59`, name: "SEP", epMonth: 9 },
        { start: `${currentYear}-10-01T00:00`, end: `${currentYear}-10-31T23:59`, name: "OCT", epMonth: 10 },
        { start: `${currentYear}-11-01T00:00`, end: `${currentYear}-12-01T23:59`, name: "NOV", epMonth: 11 },
        { start: `${currentYear}-12-02T00:00`, end: `${currentYear}-12-31T23:59`, name: "DEC", epMonth: 12 },
    ];
}

export function convertAircraftType(aircraftName: EquipmentType) {
    const aircrafts = aircraftTable_Original;

    const aircraft = aircrafts.find(a => a.EQ === aircraftName.EQ && a.short === aircraftName.short);
    if (aircraft) {
        return { EQ: aircraft.EQ, short: aircraft.short, long: aircraft.long };
    }
    else {
        return { EQ: '00', short: '---', long: 'unknown' }
    }
}

export function aircraftTable() {
    return aircraftTable_NoEqCodes;
}



/** Aircraft List provided by CA Curtis DeKeyrel empNum: 604385
 * January 9, 2025
 */
export const aircraftTable_Original = [
    //Embraer
    { EQ: "4", short: "190", long: "E190 E-Jet" },
    //Airbus
    { EQ: "43", short: "330", long: "A330-200" },
    { EQ: "98", short: "330", long: "A330-300" },
    { EQ: "40", short: "A300", long: "A300-B1" },
    { EQ: "AB", short: "A300", long: "A300-600" },
    { EQ: "67", short: "A319", long: "A319 Basic" },
    { EQ: "91", short: "A319", long: "A319 Sharklet" },
    { EQ: "92", short: "A319", long: "A319" },
    { EQ: "73", short: "A320", long: "A320" },
    { EQ: "29", short: "A320", long: "A320 Basic" },
    { EQ: "76", short: "A321", long: "A321 Sharklet" },
    { EQ: "77", short: "A321", long: "A321 Non-Sharklet" },
    { EQ: "80", short: "A321", long: "A321-T Sharklet" },
    { EQ: "75", short: "A321", long: "A321 Sharklet ETOPS" },
    { EQ: "63", short: "A321", long: "A321 Non-Sharklet" },
    { EQ: "26", short: "A321", long: "A321NX" }, //! Same EQ as B757
    { EQ: "64", short: "A321", long: "A321 Sharklet" },
    { EQ: "24", short: "A321", long: "A321NA" },
    //Boeing
    { EQ: "EC", short: "B717", long: "B717-200" },
    { EQ: "96", short: "B727", long: "B727-200 Advanced" },
    { EQ: "92", short: "B727", long: "B727-200" },
    { EQ: "98", short: "B727", long: "B727-200" },
    { EQ: "B8", short: "B737", long: "B737-800" },
    { EQ: "B9", short: "B737", long: "B737-900" },
    { EQ: "CE", short: "B737", long: "B737 Classic/NG" },
    { EQ: "45", short: "B737", long: "B737-800" },
    { EQ: "65", short: "B737", long: "B737-800" },
    { EQ: "25", short: "B737", long: "B737-MAX" },
    { EQ: "58", short: "B757", long: "B757-200" },
    { EQ: "61", short: "B757", long: "B757-200" },
    { EQ: "62", short: "B757", long: "B757-200" },
    { EQ: "B0", short: "B757", long: "B757-200" },
    { EQ: "39", short: "B757", long: "B757-200" },
    { EQ: "26", short: "B757", long: "B757-200" },  //! Same EQ as A321NX
    { EQ: "B1", short: "B757", long: "B757-300" },
    { EQ: "49", short: "B757", long: "B757-300" },
    { EQ: "BA", short: "B757", long: "B757-300" },
    { EQ: "23", short: "B767", long: "B767-200" },
    { EQ: "27", short: "B767", long: "B767-300" },
    { EQ: "34", short: "B767", long: "B767-300" },
    { EQ: "B6", short: "B767", long: "B767-300ER" },
    { EQ: "B7", short: "B767", long: "B767-300ER" },
    { EQ: "D0", short: "B767", long: "B767-300ER" },
    { EQ: "D7", short: "B767", long: "B767-300ER" },
    { EQ: "28", short: "B767", long: "B767T" },
    { EQ: "D1", short: "B767", long: "B767-300" },
    { EQ: "B2", short: "B767", long: "B767-200" },
    { EQ: "82", short: "B777", long: "B777-200ER" },
    { EQ: "83", short: "B777", long: "B777-200LR" },
    { EQ: "AE", short: "B777", long: "B777-300ER" },
    { EQ: "AF", short: "B777", long: "B777-300ER" },
    { EQ: "78", short: "B787", long: "B787-8" },
    { EQ: "96", short: "B787", long: "B787-9" },
    //Douglas
    { EQ: "31", short: "D10", long: "DC10-15" },
    { EQ: "24", short: "D10", long: "DC10-30" },
    { EQ: "29", short: "D10", long: "DC10-40F" },
    { EQ: "17", short: "D11", long: "MD11" },
    { EQ: "51", short: "D11", long: "MD11 Stretch" },
    { EQ: "54", short: "D11", long: "MD11 Engine MOD" },
    //Fokker
    { EQ: "0A", short: "F100", long: "F100 Basic" },
    { EQ: "18", short: "F100", long: "F100 MOD" },
    { EQ: "56", short: "F100", long: "F100 Special" },
    //McDonnell Douglas
    { EQ: "8C", short: "S80", long: "MD-80" },
    { EQ: "5A", short: "S80", long: "MD-80" },
    { EQ: "EF", short: "S80", long: "MD-80" },
    { EQ: "F0", short: "S80", long: "MD-80 Trainer" },
    { EQ: "F1", short: "S80", long: "MD-80 Trainer MOD" },
    { EQ: "F2", short: "S80", long: "MD-80 MOD" },
    { EQ: "A8", short: "S80", long: "MD-81" },
    { EQ: "8D", short: "S80", long: "MD-81 MOD" },
    { EQ: "A9", short: "S80", long: "MD-82" },
    { EQ: "22", short: "S80", long: "MD-83LR" },
    { EQ: "32", short: "S80", long: "MD-83LR MOD" },
    { EQ: "33", short: "S80", long: "MD-83LR MOD" },
    { EQ: "50", short: "S80", long: "MD-87 Short" },
    { EQ: "52", short: "S80", long: "MD-87 Short MOD" },
    { EQ: "35", short: "S80", long: "MD-88" },
    { EQ: "36", short: "S80", long: "MD-88 MOD" },
    { EQ: "37", short: "S80", long: "MD-88 MOD" },
    { EQ: "A6", short: "S80", long: "MD-88 MOD" },
    { EQ: "A7", short: "S80", long: "MD-80" },
    { EQ: "AA", short: "S80", long: "MD-80" },
    { EQ: "ZZ", short: "S8T", long: "MD-80 Mixed/MOD" }
];

/** Aircraft table derived from Database that includes aircraft codes 
 * March 11, 2025
*/
export const aircraftTable_EqCodes = [
    {
        mfr: "Airbus",
        fleet: [
            {
                name: "A300",
                subfleet: [
                    {
                        name: "A300-600",
                        aircraft: [
                            { "EQ": "40", "short": "A300", "long": "A300-600" },
                            { "EQ": "AB", "short": "A300", "long": "A300-600" },
                            { "EQ": "D0", "short": "A300", "long": "A300-600" }
                        ]
                    }
                ]
            },
            {
                name: "A320",
                subfleet: [
                    {
                        name: "A319",
                        aircraft: [
                            { "EQ": "29", "short": "A319", "long": "A319" },
                            { "EQ": "63", "short": "A319", "long": "A319" },
                            { "EQ": "67", "short": "A319", "long": "A319" },
                            { "EQ": "73", "short": "A319", "long": "A319" },
                            { "EQ": "77", "short": "A319", "long": "A319" },
                            { "EQ": "80", "short": "A319", "long": "A319" },
                            { "EQ": "91", "short": "A319", "long": "A319" },
                            { "EQ": "92", "short": "A319", "long": "A319" }
                        ]
                    },
                    {
                        name: "A320",
                        aircraft: [
                            { "EQ": "29", "short": "A320", "long": "A320" },
                            { "EQ": "63", "short": "A320", "long": "A320" },
                            { "EQ": "67", "short": "A320", "long": "A320" },
                            { "EQ": "73", "short": "A320", "long": "A320" },
                            { "EQ": "77", "short": "A320", "long": "A320" },
                            { "EQ": "91", "short": "A320", "long": "A320" },
                            { "EQ": "92", "short": "A320", "long": "A320" }
                        ]
                    },
                    {
                        name: "A321",
                        aircraft: [
                            { "EQ": "26", "short": "A321", "long": "A321NX" },
                            { "EQ": "26", "short": "A321", "long": "A321 Non-Sharklet" },
                            { "EQ": "29", "short": "A321", "long": "A321 Non-Sharklet" },
                            { "EQ": "45", "short": "A321", "long": "A321 Non-Sharklet" },
                            { "EQ": "63", "short": "A321", "long": "A321 Non-Sharklet" },
                            { "EQ": "64", "short": "A321", "long": "A321 Non-Sharklet" },
                            { "EQ": "67", "short": "A321", "long": "A321 Non-Sharklet" },
                            { "EQ": "73", "short": "A321", "long": "A321 Non-Sharklet" },
                            { "EQ": "75", "short": "A321", "long": "A321 Non-Sharklet" },
                            { "EQ": "76", "short": "A321", "long": "A321 Non-Sharklet" },
                            { "EQ": "77", "short": "A321", "long": "A321 Non-Sharklet" },
                            { "EQ": "91", "short": "A321", "long": "A321 Non-Sharklet" },
                            { "EQ": "92", "short": "A321", "long": "A321 Non-Sharklet" }
                        ]
                    }
                ]
            },
            {
                name: "A330",
                subfleet: [
                    {
                        name: "A330-200",
                        aircraft: [
                            { "EQ": "43", "short": "A330", "long": "A330-200" },
                            { "EQ": "98", "short": "A330", "long": "A330-200" }
                        ]
                    },
                    {
                        name: "A330-300",
                        aircraft: [
                            { "EQ": "43", "short": "A330", "long": "A330-300" },
                            { "EQ": "98", "short": "A330", "long": "A330-300" }
                        ]
                    }
                ]
            }
        ]
    },
    {
        mfr: "Boeing",
        fleet: [
            {
                name: "B727",
                subfleet: [
                    {
                        name: "B727-227",
                        aircraft: [
                            { "EQ": "92", "short": "B727", "long": "B727-200" },
                            { "EQ": "96", "short": "B727", "long": "B727-200" },
                            { "EQ": "98", "short": "B727", "long": "B727-200" },
                            { "EQ": "96", "short": "B727", "long": "B727-200 Advanced" }
                        ]
                    }
                ]
            },
            {
                name: "B737",
                subfleet: [
                    {
                        name: "B737D",
                        aircraft: [
                            { "EQ": "25", "short": "B737", "long": "B737-800" },
                            { "EQ": "29", "short": "B737", "long": "B737-800" },
                            { "EQ": "45", "short": "B737", "long": "B737-800" },
                            { "EQ": "65", "short": "B737", "long": "B737-800" },
                            { "EQ": "B8", "short": "B737", "long": "B737-800" },
                            { "EQ": "B9", "short": "B737", "long": "B737-800" },
                            { "EQ": "CE", "short": "B737", "long": "B737-800" }
                        ]
                    },
                    {
                        name: "B737M",
                        aircraft: [
                            { "EQ": "25", "short": "B737", "long": "B737-MAX" },
                            { "EQ": "45", "short": "B737", "long": "B737-MAX" },
                            { "EQ": "65", "short": "B737", "long": "B737-MAX" },
                            { "EQ": "B8", "short": "B737", "long": "B737-MAX" },
                            { "EQ": "B9", "short": "B737", "long": "B737-MAX" }
                        ]
                    }
                ]
            },
            {
                name: "B767",
                subfleet: [
                    {
                        "name": "B-757-200",
                        aircraft: [
                            { "EQ": "26", "short": "B757", "long": "B-757-200" },
                            { "EQ": "28", "short": "B757", "long": "B-757-200" },
                            { "EQ": "34", "short": "B757", "long": "B-757-200" }
                        ]
                    },
                    {
                        name: "B767-200",
                        aircraft: [
                            { "EQ": "23", "short": "B767", "long": "B767-200" },
                            { "EQ": "27", "short": "B767", "long": "B767-200" }
                        ]
                    },
                    {
                        name: "B767-300ER",
                        aircraft: [
                            { "EQ": "27", "short": "B767", "long": "B767-300ER" },
                            { "EQ": "34", "short": "B767", "long": "B767-300ER" },
                            { "EQ": "40", "short": "B767", "long": "B767-300ER" }
                        ]
                    }
                ]
            },
            {
                name: "B777",
                subfleet: [
                    {
                        name: "B777-200",
                        aircraft: [
                            { "EQ": "82", "short": "B777", "long": "B777-200LR" },
                            { "EQ": "83", "short": "B777", "long": "B777-200LR" },
                            { "EQ": "AE", "short": "B777", "long": "B777-200LR" },
                            { "EQ": "AF", "short": "B777", "long": "B777-200LR" }
                        ]
                    },
                    {
                        name: "B777-300",
                        aircraft: [
                            { "EQ": "83", "short": "B777", "long": "B777-200ER" },
                            { "EQ": "AE", "short": "B777", "long": "B777-200ER" },
                            { "EQ": "AF", "short": "B777", "long": "B777-200ER" },
                            { "EQ": "82", "short": "B777", "long": "B777-300ER" }
                        ]
                    }
                ]
            },
            {
                name: "B787",
                subfleet: [
                    {
                        name: "B787-800",
                        aircraft: [
                            { "EQ": "78", "short": "B787", "long": "B787-8" },
                            { "EQ": "96", "short": "B787", "long": "B787-8" }
                        ]
                    },
                    {
                        name: "B787-900",
                        aircraft: [
                            { "EQ": "78", "short": "B787", "long": "B787-9" },
                            { "EQ": "96", "short": "B787", "long": "B787-9" }
                        ]
                    }
                ]
            }
        ]
    },
    {
        mfr: "Douglas",
        fleet: [
            {
                name: "DC10",
                subflee: [
                    {
                        name: "DC10-10F",
                        aircraft: [
                            { "EQ": "29", "short": "DC10", "long": "DC10-10F" }
                        ]
                    },
                    {
                        name: "DC10-15",
                        aircraft: [
                            { "EQ": "29", "short": "DC10", "long": "DC10-10F" },
                            { "EQ": "31", "short": "DC10", "long": "DC10-10F" },
                            { "EQ": "29", "short": "DC10", "long": "DC10-15" },
                            { "EQ": "31", "short": "DC10", "long": "DC10-15" }
                        ]
                    },
                    {
                        name: "DC10-30",
                        aircraft: [
                            { "EQ": "24", "short": "DC10", "long": "DC10-30" }
                        ]
                    }
                ]
            }
        ]
    },
    {
        mfr: "McDonnell Douglas",
        fleet: [
            {
                name: "DC10",
                subfleet: [
                    {
                        name: "MD-11 F",
                        aircraft: [
                            { "EQ": "17", "short": "MD11", "long": "MD-11 F" },
                            { "EQ": "54", "short": "MD11", "long": "MD-11 F" }
                        ]
                    }
                ]
            },
            {
                name: "S80",
                subfleet: [
                    {
                        name: "MD-81",
                        aircraft: [
                            { "EQ": "A8", "short": "S80", "long": "MD-81" },
                            { "EQ": "8D", "short": "S80", "long": "MD-81 Mod" }
                        ]
                    },
                    {
                        name: "MD-82",
                        aircraft: [
                            { "EQ": "22", "short": "S80", "long": "MD-82" },
                            { "EQ": "32", "short": "S80", "long": "MD-82" },
                            { "EQ": "35", "short": "S80", "long": "MD-82" },
                            { "EQ": "43", "short": "S80", "long": "MD-82" },
                            { "EQ": "50", "short": "S80", "long": "MD-82" },
                            { "EQ": "52", "short": "S80", "long": "MD-82" },
                            { "EQ": "5A", "short": "S80", "long": "MD-82" },
                            { "EQ": "73", "short": "S80", "long": "MD-82" },
                            { "EQ": "A7", "short": "S80", "long": "MD-82" },
                            { "EQ": "A9", "short": "S80", "long": "MD-82" },
                            { "EQ": "EF", "short": "S80", "long": "MD-82" },
                            { "EQ": "22", "short": "S80", "long": "MD-82 Short Field" },
                            { "EQ": "52", "short": "S80", "long": "MD-82 Short Field" },
                            { "EQ": "73", "short": "S80", "long": "MD-82 Short Field" },
                            { "EQ": "EF", "short": "S80", "long": "MD-82 Short Field" }
                        ]
                    },
                    {
                        name: "MD-83",
                        aircraft: [
                            { "EQ": "22", "short": "S80", "long": "MD-83" },
                            { "EQ": "32", "short": "S80", "long": "MD-83" },
                            { "EQ": "33", "short": "S80", "long": "MD-83" },
                            { "EQ": "35", "short": "S80", "long": "MD-83" },
                            { "EQ": "36", "short": "S80", "long": "MD-83" },
                            { "EQ": "50", "short": "S80", "long": "MD-83" },
                            { "EQ": "8C", "short": "S80", "long": "MD-83" },
                            { "EQ": "A8", "short": "S80", "long": "MD-83" },
                            { "EQ": "EF", "short": "S80", "long": "MD-83" },
                            { "EQ": "22", "short": "S80", "long": "MD-83 LR Mod" },
                            { "EQ": "32", "short": "S80", "long": "MD-83 LR Mod" },
                            { "EQ": "33", "short": "S80", "long": "MD-83 LR Mod" },
                            { "EQ": "EF", "short": "S80", "long": "MD-83 LR Mod" },
                            { "EQ": "EF", "short": "S80", "long": "MD-83 Short Field" }
                        ]
                    },
                    {
                        name: "MD-87",
                        aircraft: [
                            { "EQ": "A7", "short": "S80", "long": "MD-87" },
                            { "EQ": "A9", "short": "S80", "long": "MD-87" },
                            { "EQ": "50", "short": "S80", "long": "MD-87 Short" }
                        ]
                    },
                    {
                        name: "MD-88",
                        aircraft: [
                            { "EQ": "35", "short": "S80", "long": "MD-88" },
                            { "EQ": "35", "short": "S80", "long": "MD-88 Mod" },
                            { "EQ": "36", "short": "S80", "long": "MD-88 Mod" },
                            { "EQ": "A6", "short": "S80", "long": "MD-88 Mod" },
                            { "EQ": "EF", "short": "S80", "long": "MD-88 Mod" }
                        ]
                    }
                ]
            }
        ]
    },
    {
        mfr: "Embraer",
        fleet: [
            {
                name: "E190",
                subfleet: [
                    {
                        name: "E190",
                        aircraft: [
                            { "EQ": "4", "short": "E190", "long": "E190 E-Jet" }
                        ]
                    }
                ]
            }
        ]
    },
    {
        mfr: "Fokker",
        fleet: [
            {
                name: "F100",
                subfleet: [
                    {
                        name: "F100 Basic",
                        aircraft: [
                            { "EQ": "0A", "short": "F100", "long": "F100 Basic" },
                            { "EQ": "18", "short": "F100", "long": "F100 Basic" }
                        ]
                    },
                    {
                        name: "F100 MOD",
                        aircraft: [
                            { "EQ": "0A", "short": "F100", "long": "F100 MOD" },
                            { "EQ": "18", "short": "F100", "long": "F100 MOD" }
                        ]
                    },
                    {
                        name: "F100 Special",
                        aircraft: [
                            { "EQ": "56", "short": "F100", "long": "F100 Special" }
                        ]
                    }
                ]
            }
        ]
    }
]

/** Aircraft table derived from Database that does not include aircraft codes 
 * March 11, 2025
*/
export const aircraftTable_NoEqCodes = [
    {
        mfr: "Airbus",
        fleet: [
            { "short": "A300", "long": "A300-600" },
            { "short": "A319", "long": "A319" },
            { "short": "A319", "long": "A319 Basic" },
            { "short": "A319", "long": "A319 Sharklet" },
            { "short": "A320", "long": "A320" },
            { "short": "A320", "long": "A320 Basic" },
            { "short": "A321", "long": "A321NX" },
            { "short": "A321", "long": "A321NA" },
            { "short": "A321", "long": "A321 Basic" },
            { "short": "A321", "long": "A321 Non-Sharklet" },
            { "short": "A321", "long": "A321 Sharklet" },
            { "short": "A321", "long": "A321 T-Sharklet" },
            { "short": "A330", "long": "A330-200" },
            { "short": "A330", "long": "A330-300" }
        ]
    },
    {
        mfr: "Boeing",
        fleet: [
            { "short": "B727", "long": "B727-200" },
            { "short": "B727", "long": "B727-200 Advanced" },
            { "short": "B737", "long": "B737-800" },
            { "short": "B737", "long": "B737-MAX" },
            { "short": "B757", "long": "B-757-200" },
            { "short": "B767", "long": "B767-200" },
            { "short": "B767", "long": "B767-300ER" },
            { "short": "B777", "long": "B777-200LR" },
            { "short": "B777", "long": "B777-200ER" },
            { "short": "B777", "long": "B777-300ER" },
            { "short": "B787", "long": "B787-8" },
            { "short": "B787", "long": "B787-9" }
        ]
    },
    {
        mfr: "Douglas",
        fleet: [
            { "short": "DC10", "long": "DC10-10F" },
            { "short": "DC10", "long": "DC10-10F" },
            { "short": "DC10", "long": "DC10-15" },
            { "short": "DC10", "long": "DC10-30" }
        ]
    },
    {
        mfr: "Embraer",
        fleet: [
            { "short": "E190", "long": "E190 E-Jet" }
        ]
    },
    {
        mfr: "Fokker",
        fleet: [
            { "short": "F100", "long": "F100 Basic" },
            { "short": "F100", "long": "F100 MOD" },
            { "short": "F100", "long": "F100 Special" }
        ]
    },
    {
        mfr: "McDonnell Douglas",
        fleet: [
            { "short": "MD11", "long": "MD-11 F" },
            { "short": "S80", "long": "MD-81" },
            { "short": "S80", "long": "MD-81 Mod" },
            { "short": "S80", "long": "MD-82" },
            { "short": "S80", "long": "MD-82 Short Field" },
            { "short": "S80", "long": "MD-83" },
            { "short": "S80", "long": "MD-83 LR Mod" },
            { "short": "S80", "long": "MD-83 Short Field" },
            { "short": "S80", "long": "MD-87" },
            { "short": "S80", "long": "MD-87 Short" },
            { "short": "S80", "long": "MD-88" },
            { "short": "S80", "long": "MD-88 Mod" }
        ]
    },
]
